module.exports = __webpack_public_path__ + "img/carrousel-rad-digi-sala-1.79e950cf.png";